import axiosInstance from './axiosInstance'

export const getShippingOptionById = (optionId) => {
  return axiosInstance.get(`/shipping-options/${optionId}`)
}

export const getShippingOptions = (page = 1, limit = 50, search = '', orderByKey = 'id', direction = 'asc') => {
  return axiosInstance.get(`/shipping-options?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}`)
}

export const createShippingOption = (data) => {
  return axiosInstance.post('/shipping-options', data)
}

export const updateShippingOption = (optionId, data) => {
  return axiosInstance.put(`/shipping-options/${optionId}`, data)
}

export const deleteShippingOption = (optionId) => {
  return axiosInstance.delete(`/shipping-options/${optionId}`)
}
